import React, { useState } from 'react';
import StepsOutline from './StepsOutline';
import CanvasV2 from './CanvasV2';
import InspectorV2 from './InspectorV2';
import './PathEditorV2.scss';

// Path Editor v2 shell — three zones: steps outline (left), page-builder canvas
// (center), contextual inspector (right). Holds the inspector "scope": clicking
// the hero selects the path (Path inspector); clicking a step selects the step
// (Step inspector). Selecting an element always takes precedence downstream.
const PathEditorShell = ({ previewDevice = 'desktop' }) => {
  const [scope, setScope] = useState('step');
  return (
    <div className="un-pe-shell">
      <StepsOutline />
      <CanvasV2
        previewDevice={previewDevice}
        onSelectPath={() => setScope('path')}
        onSelectStep={() => setScope('step')}
      />
      <InspectorV2 scope={scope} />
    </div>
  );
};

export default PathEditorShell;
